import React, { useState, useEffect, useMemo } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { some } from 'lodash';
import moment from 'moment';
import Loader from '../../../../Components/Utility/Loader/Loader';
import DuplicateDeleteModal from '../../../../Components/ModalPopup/DuplicateDeleteModal';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import * as actions from '../../store/SupplierSuggestion.action';

function ProductSuggestion({ suggestionData, suggestionType, approveReject, match, updatedSuggestionLibrary, updateData }) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const reducer = useSelector((reducerstate) => reducerstate);
  const [loader, setLoader] = useState(false);
  const { Measuremets, SupplierSuggestion, UserDetails } = reducer;
  const [oldData, setOldData] = useState({});
  const [showApproveRejectPopup, setShowApproveRejectPopup] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [approveRejectComment, setApproveRejectComment] = useState();
  const [checkBoxDisabled, setCheckBoxDisabled] = useState(false);

  const { editedDevOrderData } = Measuremets;
  const { duplicateCodeModal } = SupplierSuggestion;
  const { userInfo } = UserDetails;

  useEffect(() => {
    if (editedDevOrderData) {
      setOldData(editedDevOrderData);
    }
  }, [editedDevOrderData]);
  useEffect(() => {
    updatedSuggestionLibrary(suggestionData?.productInformationLibraries);
  }, [suggestionData?.productInformationLibraries]);
  useEffect(() => {
    if (selectedIdArray.length || suggestionData?.productInformationLibraries.length) {
      if (suggestionData?.productInformationLibraries.length === 1) {
        setSelectedIdArray([{ _id: suggestionData?.productInformationLibraries[0]?._id }]);
      } else {
        setSelectedIdArray([...selectedIdArray]);
      }
      setShowApproveRejectPopup(approveReject?.status);
      setConfirmAction(approveReject?.action);
    }
  }, [approveReject, suggestionData?.productInformationLibraries]);

  useEffect(() => {
    if (suggestionData?.productInformationLibraries) {
      const newBomLibrary =
        suggestionData?.productInformationLibraries?.length > 0 &&
        suggestionData.productInformationLibraries.map((item) => {
          const oldProductData =
            Array.isArray(oldData) &&
            oldData.filter((e) => {
              return e._id === item._id;
            });
          if (oldProductData?.length === 0 && suggestionType !== 'new' && item.status !== 'Approved') {
            return {
              ...item,
              status: 'Deleted',
            };
          }
          return {
            ...item,
          };
        });
      if (newBomLibrary) {
        allTypesStatusLengthCheck(newBomLibrary);
      }
    }
  }, [suggestionData?.productInformationLibraries]);

  const setBomStatus = (item) => {
    switch (item.status) {
      case 'Approved':
        return <div className=" bom-approved" />;
      case 'Rejected':
        return <div className=" bom-rejected" />;
      case 'Deleted':
        return <div className=" bom-deleted" />;
      default:
        return <div className=" bom-pending " />;
    }
  };

  function compareFactories(oldData, suggestionItem) {
    const oldFactoryIds = oldData?.factories?.map((f) => f?._id) || [];
    const oldSupplierFactoryIds = oldData?.supplierFactories || [];
    const allOldFactoryIds = [
      ...new Set([...(Array.isArray(oldFactoryIds) ? oldFactoryIds : []), ...(Array.isArray(oldSupplierFactoryIds) ? oldSupplierFactoryIds : [])]),
    ].filter(Boolean);
    const suggestionFactoryIds = suggestionItem?.factories?.map((f) => f?._id) || [];
    const suggestionSupplierFactoryIds = suggestionItem?.supplierFactories || [];
    const allSuggestionFactoryIds = [
      ...new Set([
        ...(Array.isArray(suggestionFactoryIds) ? suggestionFactoryIds : []),
        ...(Array.isArray(suggestionSupplierFactoryIds) ? suggestionSupplierFactoryIds : []),
      ]),
    ].filter(Boolean);
    return allSuggestionFactoryIds.filter((id) => id && !allOldFactoryIds.includes(id));
  }

  const processedSuggestions = useMemo(() => {
    if (!suggestionData?.productInformationLibraries) return [];

    return suggestionData.productInformationLibraries.map((item) => {
      const newFactoryIds = compareFactories(editedDevOrderData || {}, item);

      return {
        ...item,
        factories:
          item.factories?.map((factory) => ({
            ...factory,
            isNew: newFactoryIds.includes(factory._id),
          })) || [],
      };
    });
  }, [editedDevOrderData, suggestionData, compareFactories]);
  const allTypesStatusLengthCheck = (array) => {
    let totalBomApproved = 0;
    let totalBomPending = 0;
    let totalBomRejected = 0;

    totalBomApproved = array.filter((item) => item.status === 'Approved').length;

    totalBomPending = array.filter((item) => item.status === 'Pending' || item.status === 'pending').length;

    totalBomRejected = array.filter((item) => item.status === 'Rejected').length;

    if (totalBomApproved && totalBomPending === 1 && totalBomRejected === 0) {
      const id = array.filter((item) => item.status === 'Pending' || item.status === 'pending')[0]._id;
      setSelectedIdArray([{ _id: id }]);
      setCheckBoxDisabled(true);
    }

    if (totalBomApproved && totalBomPending === 0 && totalBomRejected === 1) {
      const id = array.filter((item) => item.status === 'Rejected')[0]._id;
      setSelectedIdArray([{ _id: id }]);
      setCheckBoxDisabled(true);
    }
  };
  const onCheck = async (_e, id) => {
    const selectedItemsIds = [...selectedIdArray];
    if (!some(selectedItemsIds, { _id: id })) {
      selectedItemsIds.push({ _id: id });
    } else {
      const tmpIndex = selectedItemsIds.map((idObj) => idObj._id).indexOf(id);
      selectedItemsIds.splice(tmpIndex, 1);
    }
    setSelectedIdArray([...selectedItemsIds]);
  };

  const handleApproveReject = async (action) => {
    setLoader(true);
    const highlightedValues = processedSuggestions
      .map((item) => ({
        productInformationId: item._id,
        highlightedFactories: item.factories?.filter((factory) => factory.isNew)?.map((factory) => factory._id) || [],
      }))
      .filter((item) => item.highlightedFactories.length > 0);

    const obj = {
      suggestionId: match?.params?.id,
      componentId: selectedIdArray,
      comment: approveRejectComment,
      section: 'product-information',
      highlightedArr: highlightedValues,
    };
    if (confirmAction === 'Approved') {
      obj.type = suggestionType;
    }

    if (action && selectedIdArray.length) {
      const res = await dispatch(actions.approveRejectSuggestion(confirmAction, obj, t));
      if (res) {
        setShowApproveRejectPopup(false);
        updateData();
      }
    }
    setLoader(false);
  };
  const handleCommentChange = (e) => {
    setApproveRejectComment(e.target.value);
  };
  const setInfoContent = () => {
    return suggestionData?.productInformationLibraries.length === 1 ? 'info-content' : 'info-content right';
  };
  const closeDuplicateDeleteModal = () => {
    dispatch(actions.setDuplicateCodeModal(false, null));
  };

  const rejectedTitle = confirmAction === 'Rejected' ? t('SUPPLIER_SUGGESTION.CONFIRM.TITLE_REJECT') : '';
  const rejectedMessage = confirmAction === 'Rejected' ? t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE_REJECT') : '';
  const oldFactoryCase = () => {
    return oldData?.factories?.length ? oldData.factories.map((e) => e.factoryName).join(', ') : '-';
  };
  const suggestionDataCase = () => {
    return suggestionData?.productInformationLibraries?.map((e) =>
      e?.originalItem?.factories?.length ? e.originalItem.factories.map((f) => f.factoryName).join(', ') : '-',
    );
  };

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div>
          {suggestionType === 'amendment' && (
            <Row>
              {/* Original Entry card */}
              <Col md={6}>
                <Card className="rounded-0 mb-2 card-bordered">
                  <Card.Header className="py-2 px-3">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <strong>{t('BOM.BOM_SUGGESTION_CARD.ORIGINAL_ENTRY')}</strong>
                      </div>
                    </div>
                  </Card.Header>
                  <Card.Body className="py-2 px-3">
                    <ul className="suggestion-item">
                      {suggestionData.type === 'amendment' && (
                        <li>
                          <strong>{t('SUPPLIER_SUGGESTION_DETAIL.PRODUCT_NUMBER')}&nbsp;</strong>
                          {oldData?.number || '-'}
                        </li>
                      )}
                      <li>
                        <strong>{t('SUPPLIER_SUGGESTION_DETAIL.SUPPLIER_NUMBER')}&nbsp;</strong>
                        {oldData?.suppliers?.length ? oldData.suppliers.map((e) => e.supplierName).join(', ') : '-'}
                      </li>

                      <li>
                        <strong>{t('SUPPLIER_SUGGESTION_DETAIL.SUPPLIER_FACTORY')}&nbsp;</strong>
                        {suggestionData?.productInformationLibraries?.[0]?.originalItem ? suggestionDataCase() : oldFactoryCase()}
                      </li>
                    </ul>
                  </Card.Body>
                </Card>
              </Col>
              {/* Suggested Amendment card */}
              <Col md={6}>
                <Card className="rounded-0 mb-2 card-bordered">
                  <Card.Header className="py-2 px-3">
                    <div className="d-flex align-items-center">
                      <div>
                        <strong>{t('BOM.BOM_SUGGESTION_CARD.SUGGESTION_AMENDENT')}</strong>
                      </div>
                      {suggestionData?.productInformationLibraries?.map((item, index) => (
                        <React.Fragment key={item._id}>
                          {userInfo.role !== 'Supplier' && (item.status === 'Pending' || item.status === 'Rejected') && (
                            <div className="common-checkbox ml-auto">
                              <input
                                onChange={(e) => onCheck(e, item._id)}
                                name={`check_${index}`}
                                id={`check_${item._id}`}
                                type="checkbox"
                                disabled={checkBoxDisabled}
                                checked={some(selectedIdArray, { _id: item._id })}
                              />
                              <label htmlFor={`check_${item._id}`} className="chklabel" />
                            </div>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </Card.Header>

                  <Card.Body className="py-2 px-3">
                    <ul className="suggestion-item">
                      {suggestionData.type === 'amendment' && (
                        <li>
                          <strong>{t('SUPPLIER_SUGGESTION_DETAIL.PRODUCT_NUMBER')}&nbsp;</strong>
                          {suggestionData?.productInformationLibraries?.map((e) => e?.number) || '-'}
                        </li>
                      )}
                      <li>
                        <strong>{t('SUPPLIER_SUGGESTION_DETAIL.SUPPLIER_NUMBER')}&nbsp;</strong>
                        {suggestionData?.productInformationLibraries
                          ?.map((item, index) => (item?.suppliers?.length ? item.suppliers.map((supplier) => supplier.supplierName).join(', ') : '-'))
                          .join(', ')}
                      </li>

                      <li>
                        <strong>{t('SUPPLIER_SUGGESTION_DETAIL.SUPPLIER_FACTORY')}&nbsp;</strong>
                        {processedSuggestions?.map((item, index) =>
                          item?.factories?.length
                            ? item.factories.map((factory, factoryIndex) => (
                                <span key={factory._id} className={factory.isNew ? 'bom-status-approved' : ''}>
                                  {factory.factoryName}
                                  {factoryIndex < item.factories.length - 1 ? ', ' : ''}
                                </span>
                              ))
                            : '-',
                        )}
                      </li>
                      <li className="col-12 li-half">
                        <strong>{t('BOM.BOM_SUGGESTION_CARD.STATUS')}:&nbsp;</strong>
                        {suggestionData?.productInformationLibraries?.map((e, index) => (
                          <span key={index}>
                            {e.status === 'Deleted' ? (
                              "Original Entry doesn't exist"
                            ) : (
                              <span className="text-capitalize">
                                {e.status === 'Pending' && e.status}
                                {e.status !== 'Pending' && (
                                  <>
                                    <span>{e.status}</span>
                                    <div className="info-container">
                                      <span className="icon-info" />
                                      <div className={setInfoContent()}>
                                        <p className="mb-1">
                                          <b>
                                            {e.status === 'Approved' ? t('BOM.BOM_SUGGESTION_CARD.APPROVED_BY') : t('BOM.BOM_SUGGESTION_CARD.REJECTED_BY')}
                                            &nbsp;
                                          </b>
                                          {e.approvedRejectedBy?.firstName} {e.approvedRejectedBy?.lastName}
                                        </p>
                                        <p className="mb-1">
                                          <b>
                                            {e.status === 'Approved' ? t('BOM.BOM_SUGGESTION_CARD.APPROVED_AT') : t('BOM.BOM_SUGGESTION_CARD.REJECTED_AT')}
                                            &nbsp;
                                          </b>
                                          {e.approvedRejectedAt && moment(e.approvedRejectedAt).format('DD-MMMM-YYYY hh:mm A')}
                                        </p>
                                        <p className="mb-0">
                                          <b>{t('BOM.BOM_SUGGESTION_CARD.COMMENT')}&nbsp;</b>
                                          {e.comment}
                                        </p>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </span>
                            )}
                          </span>
                        ))}
                      </li>
                    </ul>
                  </Card.Body>
                  {suggestionData?.productInformationLibraries?.map((item, index) => (
                    <div key={index}>{setBomStatus(item)}</div>
                  ))}
                </Card>
              </Col>
            </Row>
          )}
          {!suggestionData?.productInformationLibraries && suggestionData?.productInformationLibraries?.length === 0 && (
            <Col md={6}>
              <p className="text-center">{t('BOM.BOM_SUGGESTION_CARD.NO_DATA_FOUND')}</p>
            </Col>
          )}
        </div>
      )}
      {showApproveRejectPopup && (
        <ConfirmationPopup
          onOpen={showApproveRejectPopup}
          onConfirm={handleApproveReject}
          loading={false}
          title={confirmAction === 'Approved' ? t('SUPPLIER_SUGGESTION.CONFIRM.TITLE_APPROVE') : rejectedTitle}
          message={confirmAction === 'Approved' ? t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE_APPROVE') : rejectedMessage}
          toggle={() => setShowApproveRejectPopup(!showApproveRejectPopup)}
          isCommentOn
          commentText={handleCommentChange}
          comment={approveRejectComment}
        />
      )}
      {duplicateCodeModal.isOpen && (
        <DuplicateDeleteModal
          onOpen={duplicateCodeModal.isOpen}
          title={t('BOM.BOM_SUGGESTION_CARD.ERROR_LOG')}
          toggle={() => closeDuplicateDeleteModal()}
          codeItem={duplicateCodeModal?.code}
        />
      )}
    </>
  );
}

export default ProductSuggestion;
